<template>
  <div v-if="busy" class='loading-screen' style='background-color: rgba(0,0,0,0.8)'>
    <div class="loading-circle" />
    <p class="loading-text">{{ title }}</p>
  </div>  
</template>

<script>
export default {
  name: 'LoadingScreen',
  data() {
    return {
      title: 'Wait...'
    }
  },
  computed: {
    busy () {
      return this.$store.getters.Busy
    }
  }
}
</script>

<style scoped>
.loading-circle {
  width: 60px;
  height: 60px;
  border-radius: 100%;
  border: 3px solid transparent;
  border-left-color: #888787;
  animation: circleanimation .50s linear infinite
}

.loading-text {
  margin-top: 20px;
  color: #888787;
  font-size: 0.9rem;
  text-align: center;
}

.loading-screen {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 30000;
  flex-direction: column;
  user-select: none;
}

@keyframes circleanimation {
  from {
    transform: rotateZ(0deg);
  }
  to {
    transform: rotateZ(360deg);
  }
}
</style>>
